import {Injectable} from "@angular/core";
import {ToastController} from "@ionic/angular";

@Injectable({
    providedIn: 'root'
})
export class ABWToastService {
    constructor(private _toastController: ToastController) {
    }

    showToast(_message: string, _header: string = 'Erreur survenue',  position: 'top' | 'bottom' | 'middle' = 'bottom', duration: number = 5000): void {
        const toast = this._toastController.create({
            header: _header,
            message: _message,
            position: position,
            duration: duration,
        });
        toast.then(_t => _t.present());
    }
}
